import { combineReducers } from "redux";
import project from "./project";

const name = (state = { title: "After" }, action) => {
  return state;
};

export default combineReducers({ project });
